import firebase from 'firebase/app';
import 'firebase/firestore';

const config = {
    apiKey: process.env.NX_FIREBASE_API_KEY,
    authDomain: process.env.NX_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NX_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NX_FIREBASE_STORAGE_BUCKET,
    appId: process.env.NX_FIREBASE_APP_ID,
    measurementId: process.env.NX_FIREBASE_MEASUREMENT_ID
};

firebase.initializeApp(config);
const db = firebase.firestore();

export class FirebaseHelper {
    static async fetchData(path) {
        const response = db.collection(path);
        const result = await response.get();
        return result.docs;
    }
}
